import styled from 'styled-components';
import Grid from '$components/layout/Grid';
import { vars, media } from '$util/theme';
import {
  desktopButtonStandartCss,
  desktopLabelLargeCss,
  desktopTitleH1Css,
  mobileTitleH2Css,
  mobileTitleH4Css,
} from '$base-styles/typography';
import type { ReviewProvider } from '$constants/review-providers';

export const Styled = styled(Grid)<{
  $reviewsProvider?: ReviewProvider;
  $backgroundColor?: string;
  $backgroundImageUrl?: string;
}>`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${({ $backgroundColor }) => $backgroundColor};

  .Image > span {
    z-index: 1;
  }

  .image-shadow {
    height: 46%;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(0deg, #f5f4f4 0%, rgba(245, 244, 244, 0) 100%),
      linear-gradient(
        90deg,
        rgba(217, 217, 217, 0) 5.04%,
        #d9d9d9 25.4%,
        #d9d9d9 83.65%,
        rgba(217, 217, 217, 0) 95.32%
      );

    ${media.between('md', 'lg')} {
      width: 70%;
    }
  }
  .DynamicRouteVrmLookup {
    display: flex;
    margin-bottom: 30px;
    flex-direction: column;
    gap: 20px;

    ${media.up('lg')} {
      margin-bottom: 42px;
      flex-direction: row;
      gap: 0;
    }

    .input-group {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      gap: 16px;
      filter: drop-shadow(0px 4px 12px rgba(58, 58, 58, 0.12));

      ${media.up('lg')} {
        flex-direction: row;
        gap: 0;
      }

      input {
        background-color: ${vars.quantumverse.reskinColors.white};
        border-radius: 0;
        padding-top: 12px;
        padding-bottom: 12px;
        border-radius: 4px;

        ${media.up('lg')} {
          border-radius: 0;
        }
      }

      .react-autosuggest__input:focus {
        box-shadow: 0px 0px 10px rgba(21, 102, 220, 0.4);
      }

      .react-autosuggest__container {
        &:has(input:focus) {
          ::before {
            opacity: 0;
          }
        }

        ${media.up('lg')} {
          &::before {
            position: absolute;
            content: '';
            display: block;
            width: 1px;
            background-color: ${vars.quantumverse.reskinColors.neutral200};
            height: 62.5%;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
          }
        }

        .react-autosuggest__input {
          ${media.up('lg')} {
            border-radius: 6px 0px 0px 6px;
          }
        }
      }

      .FormItem {
        margin-bottom: 0;
      }
    }

    .footer-group {
      height: 48px;
      margin: 0;

      ${media.up('lg')} {
        height: auto;
      }

      .Button {
        height: 100%;
        border-radius: 4px;
        position: static;

        ${media.up('lg')} {
          border-radius: 0px 6px 6px 0px;
        }
      }
    }
  }

  .card {
    border-radius: 40px;
    background-color: #f5f4f4;
    padding: 0px 18px;

    ${media.up('sm')} {
      padding: 0 48px;
    }

    ${media.up('md')} {
      padding: 0;
    }

    .image-col {
      .Image {
        padding: 60px 0;
        min-height: 200px;
      }
    }
  }

  .headings-col {
    text-align: ${({ $backgroundImageUrl }) => ($backgroundImageUrl ? 'left' : 'center')};
    align-items: center;
    order: 2;
    ${media.up('lg')} {
      order: 0;
    }

    .headings {
      text-align: center;
      padding-bottom: 30px;

      ${media.up('lg')} {
        text-align: left;
        padding: 60px 0 44px;
      }

      .Heading {
        ${mobileTitleH2Css};
        margin-bottom: 12px;
        ${media.up('md')} {
          margin-bottom: 14px;
          ${desktopTitleH1Css};
        }
      }

      > p {
        ${mobileTitleH4Css};
        margin: 0;

        ${media.up('md')} {
          ${desktopLabelLargeCss};
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    gap: 7%;
    margin-bottom: 26px;
    flex-wrap: wrap;
    align-items: flex-start;

    ${media.up('lg')} {
      margin-bottom: 48px;
      align-items: center;
    }

    .TrustPilot {
      /* flex: 1 1 50%; */

      ${media.up('lg')} {
        /* flex: 1 1 33%; */
      }

      iframe {
        width: 120px;
        height: 90px;
        ${media.up('lg')} {
          height: 40px;
          width: auto;
        }
      }
    }

    .AllianzInsured {
      flex-direction: column;
      row-gap: 5px;
    }

    .GoogleReviewsSummary a {
      row-gap: 0;
      justify-content: center;
      flex-direction: column;

      .score-wrapper {
        column-gap: 6px;
      }

      .reviews-text {
        display: none;
      }
    }

    .call-us {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      border-radius: 6px;
      transition: 0.3s;
      background-color: #e4e4e4;
      margin-top: 16px;

      ${media.up('lg')} {
        margin-top: 0;
        background-color: unset;
      }

      .qvIcon {
        margin-right: 6px;
      }

      .call-us-text {
        ${desktopButtonStandartCss}
        font-weight: 600;
        color: ${vars.quantumverse.reskinColors.neutral600};

        .call-us-link {
          ${desktopButtonStandartCss}
          color: ${vars.quantumverse.reskinColors.neutral600};
          border-bottom: 1px solid ${vars.quantumverse.reskinColors.neutral600};
        }
      }

      &:hover {
        background-color: #e4e4e4;
      }
    }
  }
`;
